var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-regions-select',{attrs:{"label":_vm.$t('DELIVERY_REGIONS_SELECT.TITLE'),"regions":_vm.deliveryRegions,"value":_vm.value},on:{"input":_vm.emit}})}
var staticRenderFns = []

export { render, staticRenderFns }